export default __webpack_public_path__ + "static/media/tj-logo.2672108b.jpg";